import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import atoms from "../../../atoms";
import molecules from "../../../molecules";
import constant from "../../../../constants/constant";
import { ProductDetail, PendingProductProps } from "../interface"
import { FiEdit } from "react-icons/fi";
import { AiOutlineEye } from "react-icons/ai";
import ThreeDots from '../../../../assets/Images/threeDots.svg'
import { Pending_Product_Columns, Pending_Product_Columns_ContactLens } from "./product.const";
import { ProductFilterMobileUI, ProductFilterModule } from "./components";


const { Search, Button, Table, Image, Pagination } = atoms
const { SidePopUp, ConfirmationModal, ContactLensContainer, ProductFilter } = molecules

const Index: React.FC<PendingProductProps> = (
    { productResponse,
        isRecognize,
        setLimitPerPage,
        currentPage,
        setCurrentPage,
        setSearch,
        limit,
        productDetail,
        getDetailById,
        updateVerificationStatus,
        setIsContactLensProduct,
        isContactLensProduct,
        showFilter,
        setShowFilter,
        brandList,
        productTypeList,
        handleChange,
        filterData
    }) => {
    const navigate = useNavigate()
    const inputRef: any = useRef()
    const [showSidebarModal, setShowSidebarModal] = useState(false)
    const [deletePopup, setDeletePopup] = useState<boolean>(false)

    const showImage = (imageUrl: any, index: any) => {

    }

    const handleLensTypeChange = (value: boolean) => {
        setCurrentPage(1);
        setSearch('')
        setIsContactLensProduct(value)
    }

    useEffect(() => {
        if (inputRef?.current) {
            inputRef.current.value = "";
        }
    }, [isRecognize, isContactLensProduct]);
    return (
        <>
            <ProductFilterModule
                inputRef={inputRef}
                setCurrentPage={setCurrentPage}
                setSearch={setSearch}
                isContactLensProduct={isContactLensProduct}
                handleLensTypeChange={handleLensTypeChange}
                showFilter={showFilter}
                setShowFilter={setShowFilter}
                isRecognize={isRecognize}
                navigate={navigate}
                filterData={filterData}
                brandList={brandList}
                handleChange={handleChange}
                productTypeList={productTypeList}
            />
            <div >
                <Table columns={isContactLensProduct ? Pending_Product_Columns_ContactLens : Pending_Product_Columns}
                    AdditionalClassName="data-table-container"
                    data={productResponse?.data?.map((item: ProductDetail, index: number) => {
                        return ({
                            ...item,
                            isActive: item.isActive ? (
                                <div className="background-light-green border-product-radius">
                                    <p className="color-green m-1 p-1">{constant.STATUS.ACTIVE}</p>
                                </div>) : <div className="background-light-red border-product-radius">
                                <p className="color-red m-1 p-1">{constant.STATUS.DEACTIVE}</p>
                            </div>,
                            verification_status: item.verification_status === constant.VERIFICATION_STATUS.PENDING ? (
                                <div className="background-light-yellow border-product-radius"><p className="color-yellow m-1 p-1">{'Pending'}</p></div>) : item.verification_status === constant.VERIFICATION_STATUS.VERIFIED ?
                                (<div className="background-light-green border-product-radius"><p className="color-green m-1 p-1">{"Verified"}</p></div>) : item.verification_status === constant.VERIFICATION_STATUS.REWORK ? (<div className="background-light-red border-product-radius"><p className="color-red m-1 p-1">{"Rejected"}</p></div>) : ''
                            ,
                            action:
                                <> <div className='table-data-width'>
                                    <button
                                        className="btn dropdown-dots shadow-none action-button"
                                        type="button"
                                        id="dropdownMenuButton1"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                    >
                                        <Image src={ThreeDots} />
                                    </button>
                                    <ul
                                        className="dropdown-menu dropdown-menu-end dropdown-style"
                                        aria-labelledby="dropdownMenuButton1"
                                    >
                                        <li>
                                            {/* {item.verification_status === constant.VERIFICATION_STATUS.VERIFIED ? ( */}
                                            <button
                                                className="dropdown-item dropdown-item-size"
                                                onClick={() => {
                                                    getDetailById(item.id);
                                                    setShowSidebarModal(true);
                                                }}
                                            >
                                                <div className='d-flex align-items-center'>
                                                    <AiOutlineEye />
                                                    <span className='ms-2 mb-0'>View</span>
                                                </div>
                                            </button>
                                        </li>

                                        {/* ) : ( */}
                                        {
                                            <>
                                                <li>
                                                    <hr className="my-1"></hr>
                                                </li>
                                                <li>
                                                    <button
                                                        className="dropdown-item dropdown-item-size"
                                                        onClick={() => navigate(`/product/edit/${item.id}?isRecognize=${isRecognize ? constant.BRAND_CATEGORY[0].value : constant.BRAND_CATEGORY[1].value}`)}
                                                    >
                                                        <div className='d-flex align-items-center'>
                                                            <FiEdit />
                                                            <span className='ms-2 mb-0'>Edit</span>
                                                        </div>
                                                    </button>

                                                </li>
                                            </>
                                        }
                                        {
                                            <>
                                                <li>
                                                    <hr className="my-1"></hr>
                                                </li>
                                                <li>
                                                    <button
                                                        className="dropdown-item dropdown-item-size"
                                                        onClick={() =>
                                                            navigate(
                                                                `/product/edit/${item.id
                                                                }?isDuplicate=${true}&isRecognize=${isRecognize ? constant.BRAND_CATEGORY[0].value : constant.BRAND_CATEGORY[1].value}`
                                                            )
                                                        }
                                                    >
                                                        <div className="d-flex align-items-center">
                                                            <FiEdit />
                                                            <span className="ms-2 mb-0">Duplicate</span>
                                                        </div>
                                                    </button>
                                                    {/* )} */}
                                                </li>
                                            </>
                                        }
                                    </ul>
                                </div></>
                        })
                    })}
                />
            </div>
            <div>
                <Pagination
                    totalCount={productResponse?.count}
                    currentPage={currentPage}
                    totalPages={productResponse?.totalPages}
                    onChangePage={(page: any) => setCurrentPage(page)}
                    setLimit={(e: number) => { setCurrentPage(1); setLimitPerPage(e) }}
                    limit={limit}
                />
            </div>
            {showSidebarModal && <div>
                <SidePopUp show={showSidebarModal}
                    onHide={() => setShowSidebarModal(false)}
                    productDetail={productDetail}
                    showImage={(imageUrl: any, index: any) => showImage(imageUrl, index)}
                    updateVerificationStatus={(id: string, status: number) => updateVerificationStatus(id, status)}
                    isBrandedCategory={false}
                />
            </div>}
            {deletePopup && <ConfirmationModal
                show={deletePopup}
                handleConfirmItem={() => { setDeletePopup(!deletePopup) }}
                onHide={() => setDeletePopup(!deletePopup)}
                message={'delete this product'} />}
            {showFilter && <ProductFilter
                show={showFilter}
                header="Filter"
                onHide={() => setShowFilter(!showFilter)}
                buttonDisable={false}
                handleSubmit={() => setShowFilter(!showFilter)}
                submitBtnText="Apply"

            >
                <ProductFilterMobileUI
                    brandList={brandList}
                    productTypeList={productTypeList}
                    handleChange={handleChange}
                    filterData={filterData}
                    isContactLensProduct={isContactLensProduct}
                />
            </ProductFilter>}
        </>
    )
}
export default Index